import React, { useEffect } from 'react';
import { object, string } from 'prop-types';

// Import helpers
import { phoneCodes } from 'helpers/phone_codes';
import {
	COUNTRY_FLAG_CDN,
	AUTH_FIELDS_NAMES,
	UNKNOWN_DIAL_CODE
} from 'components/views/authentication/login/firebase_auth/helpers';

// Import styles
import { StyledFlag } from 'components/views/authentication/login/firebase_auth/style';

const { DIAL_CODE } = AUTH_FIELDS_NAMES;

const CountryFlag = ({ country, formRef }) => {
	const { dialCode } = phoneCodes.find(({ iso2 }) => iso2 === country);

	useEffect(() => {
		const { current: formik } = formRef;

		const newDialCode = dialCode || UNKNOWN_DIAL_CODE;

		// set new dial code
		formik.setFieldValue(DIAL_CODE, newDialCode, false);

		// eslint-disable-next-line
	}, [country, formRef]);

	return dialCode && <StyledFlag src={`${COUNTRY_FLAG_CDN}/${country}.svg`} />;
};

CountryFlag.propTypes = {
	country: string.isRequired,
	formRef: object.isRequired
};

export default CountryFlag;
